module.exports = "<p>בתחתית כל מודעה של דירה מופיע מחשבון משכנתא. אם תמלאו את הפרטים, תגלו מה גובה המשכנתא לו אתם נזקקים ומה יהיה גובה ההחזר החודשי שלכם. שימו לב! גובה ההחזרים החודשיים שתשלמו לאורך כל תקופת החזר המשכנתא, תלוי במסלול בו תבחרו ובגובה הריבית עליו תגיעו להסכמה עם בנק המשכנתאות. הסכום שמנבא מחשבון המשכנתא באתר מבוסס על חישוב של ריבית בגובה 3%. לכן הוא בגדר הערכה כללית ונועד לסבר את האוזן בלבד.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/help/he/11.md
// module id = 801
// module chunks = 0